/* Albisia accessibility adjustments panel.
   Toggles classes on <html>, saves them on the device, and keeps the panel
   itself fully keyboard-operable. Companion: assets/albisia-a11y.css */
(function () {
  'use strict';

  var KEY = 'albisia-a11y';
  var ALL = ['a11y-text-1', 'a11y-text-2', 'a11y-contrast', 'a11y-font', 'a11y-spacing',
             'a11y-links', 'a11y-motion', 'a11y-cursor', 'a11y-guide'];
  var root = document.documentElement;
  var wrap = document.getElementById('albisia-a11y');
  if (!wrap) return;

  var trigger = wrap.querySelector('[data-a11y-trigger]');
  var panel = wrap.querySelector('[data-a11y-panel]');
  var closeBtn = wrap.querySelector('[data-a11y-close]');
  var toggles = wrap.querySelectorAll('[data-a11y-toggle]');
  var sizes = wrap.querySelectorAll('[data-a11y-text]');
  var reset = wrap.querySelector('[data-a11y-reset]');
  var guide = null;
  var state = load();

  function load() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(s) ? s : []; }
    catch (e) { return []; }
  }
  function save() {
    try { if (state.length) { localStorage.setItem(KEY, JSON.stringify(state)); } else { localStorage.removeItem(KEY); } }
    catch (e) { /* private mode: settings last for this page only */ }
  }
  function has(c) { return state.indexOf(c) > -1; }
  function set(c, on) {
    var i = state.indexOf(c);
    if (on && i === -1) state.push(c);
    if (!on && i > -1) state.splice(i, 1);
  }

  function apply() {
    ALL.forEach(function (c) { root.classList.toggle(c, has(c)); });

    Array.prototype.forEach.call(toggles, function (b) {
      b.setAttribute('aria-pressed', has(b.getAttribute('data-a11y-toggle')) ? 'true' : 'false');
    });
    var level = has('a11y-text-2') ? 2 : (has('a11y-text-1') ? 1 : 0);
    Array.prototype.forEach.call(sizes, function (b) {
      b.setAttribute('aria-pressed', Number(b.getAttribute('data-a11y-text')) === level ? 'true' : 'false');
    });

    applyMotion();
    applyGuide();
    save();
  }

  /* Pause motion: the theme reads these body flags at start-up (handled by the
     inline script in theme.liquid on reload). Here we cover the current page. */
  function applyMotion() {
    if (!has('a11y-motion')) return;
    ['data-animate_sections', 'data-animate_images', 'data-animate_buttons',
     'data-animate_underlines', 'data-transitions'].forEach(function (a) {
      document.body.setAttribute(a, 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
    });
  }

  function applyGuide() {
    if (has('a11y-guide')) {
      if (!guide) {
        guide = document.createElement('div');
        guide.id = 'a11y-guide';
        guide.setAttribute('aria-hidden', 'true');
        document.body.appendChild(guide);
        document.addEventListener('mousemove', moveGuide, { passive: true });
        document.addEventListener('touchmove', moveGuide, { passive: true });
      }
    } else if (guide) {
      guide.parentNode.removeChild(guide);
      guide = null;
      document.removeEventListener('mousemove', moveGuide);
      document.removeEventListener('touchmove', moveGuide);
    }
  }
  function moveGuide(e) {
    if (!guide) return;
    var y = e.touches ? e.touches[0].clientY : e.clientY;
    guide.style.top = y + 'px';
  }

  /* Panel open and close ------------------------------------------------- */
  function open() {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('button, a');
    if (first) first.focus();
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', onOutside, true);
  }
  function close(returnFocus) {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKey);
    document.removeEventListener('click', onOutside, true);
    if (returnFocus !== false) trigger.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); }
  }
  function onOutside(e) {
    if (!wrap.contains(e.target)) close(false);
  }

  trigger.addEventListener('click', function () {
    if (panel.hidden) { open(); } else { close(); }
  });
  closeBtn.addEventListener('click', function () { close(); });

  Array.prototype.forEach.call(toggles, function (b) {
    b.addEventListener('click', function () {
      var c = b.getAttribute('data-a11y-toggle');
      set(c, !has(c));
      apply();
    });
  });
  Array.prototype.forEach.call(sizes, function (b) {
    b.addEventListener('click', function () {
      var level = Number(b.getAttribute('data-a11y-text'));
      set('a11y-text-1', level === 1);
      set('a11y-text-2', level === 2);
      apply();
    });
  });
  reset.addEventListener('click', function () {
    var hadMotion = has('a11y-motion');
    state = [];
    apply();
    if (hadMotion) location.reload();
  });

  apply();
})();
